export const createDecisionDocHref = 'https://docs.checkmarble.com/reference/post_decisions';

export const pivotValuesDocHref = 'https://docs.checkmarble.com/docs/pivot-values';

export const fuzzyMatchingDocHref = 'https://docs.checkmarble.com/docs/string-similarity-scoring-copy';

export const stringTemplatingDocHref = 'https://docs.checkmarble.com/docs/string-templating';

export const aggregationDocHref = 'https://docs.checkmarble.com/docs/aggregations';

export const dateDocHref = 'https://docs.checkmarble.com/docs/datetime-functions';

export const scenarioObjectDocHref = 'https://docs.checkmarble.com/docs/executing-a-scenario#the-scenario-object';

export const executeAScenarioDocHref = 'https://docs.checkmarble.com/docs/executing-a-scenario#executing-a-scenario';

export const ingestingDataByCsvDocHref = 'https://docs.checkmarble.com/docs/ingesting-data#by-batch-csv-files';

export const workflowsDocHref = 'https://docs.checkmarble.com/docs/introduction-5';

export const scenarioDecisionDocHref = 'https://docs.checkmarble.com/docs/decision-1';

export const webhooksSetupDocHref = 'https://docs.checkmarble.com/docs/setting-up-the-webhooks';

export const webhooksEventsDocHref = 'https://docs.checkmarble.com/docs/available-events-and-webhooks-format';

export const ruleSnoozesDocHref = 'https://docs.checkmarble.com/docs/rule-snoozes';

export const blockingReviewDocHref = 'https://docs.checkmarble.com/docs/blocking-review';
